import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Homepage from './HomePage';
import AuthenticationPage from './AuthenticationPage';
import MainPage from './MainPage';
import CreateNewTeam from './CreateNewTeam';
import ErrorPage from './ErrorPage';
import ChangeOpponent from './ChangeOpponent';

function MyRouter() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route path="/authentication" component={AuthenticationPage} />
        <RedirectToAuthenticationPage path="/mainPagePlay" component={MainPage} />
        <Route path="/createNewTeam" component={CreateNewTeam} />
        <RedirectToAuthenticationPage path="/changeOpponent" component={ChangeOpponent} />
        <Route component={ErrorPage} />
      </Switch>
    </BrowserRouter>
  );
}

function RedirectToAuthenticationPage({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => {
        if (!localStorage.getItem('uuid')) {
          return <Redirect to="/authentication" />;
        } else {
          return <Component {...props} />;
        }
      }}
    />
  );
}

export default MyRouter;
